module.exports = __webpack_public_path__ + "h5/img/mfe_08.782f3015.jpeg";